// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cartAggsLayoutHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

.cartAggsLayoutHeaderText {
  display: flex;
  gap: 8px;
  align-items: center;
}

.cartAggsPrimayText {
  font-weight: 700;
  white-space: normal;
  word-break: break-word;
  line-height: 1.3;
}

.cartAggsQuantity {
  font-weight: 700;
  color: var(--surface-g3);
  text-transform: lowercase;
}

.cartAggsLayoutAddons {
  color: var(--surface-g4);
}

.cartAggsReturnedIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #e90000;
  background-color: #ffe5e5;
  padding: 2px;
  border-radius: 4px;
}

.cartAggsComplimentaryIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0860e6;
  background-color: #edf8ff;
  padding: 2px;
  border-radius: 4px;
}

/* ── Dark theme ── */
.dark .cartAggsReturnedIcon {
  background-color: #3b1a1a;
  color: #fca5a5;
}

.dark .cartAggsComplimentaryIcon {
  background-color: #1a2a4a;
  color: #93c5fd;
}
`, "",{"version":3,"sources":["webpack://./client/src/customComponents/CartAggsLayout/CartAggsLayout.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB","sourcesContent":[".cartAggsLayoutHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n}\n\n.cartAggsLayoutHeaderText {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.cartAggsPrimayText {\n  font-weight: 700;\n  white-space: normal;\n  word-break: break-word;\n  line-height: 1.3;\n}\n\n.cartAggsQuantity {\n  font-weight: 700;\n  color: var(--surface-g3);\n  text-transform: lowercase;\n}\n\n.cartAggsLayoutAddons {\n  color: var(--surface-g4);\n}\n\n.cartAggsReturnedIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #e90000;\n  background-color: #ffe5e5;\n  padding: 2px;\n  border-radius: 4px;\n}\n\n.cartAggsComplimentaryIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #0860e6;\n  background-color: #edf8ff;\n  padding: 2px;\n  border-radius: 4px;\n}\n\n/* ── Dark theme ── */\n.dark .cartAggsReturnedIcon {\n  background-color: #3b1a1a;\n  color: #fca5a5;\n}\n\n.dark .cartAggsComplimentaryIcon {\n  background-color: #1a2a4a;\n  color: #93c5fd;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
